module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isStory()) {;
__p += '\n    <i class="story" aria-hidden="true"></i>\n';
};
__p += '\n\n';
 if (!isVideo()) {;
__p += '\n    <div role="' +
((__t = ( ariaRole )) == null ? '' : __t) +
'" tabindex="0" ' +
((__t = ( backgroundImage(photoURL(getPhotoQuality('xl'))) )) == null ? '' : __t) +
' class="img_holder" aria-label="' +
((__t = ( I18n.t('photo_item.open_photo', { altText: altText() }) )) == null ? '' : __t) +
'">\n        <img src="' +
((__t = ( photoURL(getPhotoQuality('xl')) )) == null ? '' : __t) +
'" alt="' +
((__t = ( decode_utf8(altText()) )) == null ? '' : __t) +
'" style="position:fixed; left:-100000px;" />\n    </div>\n';
};
__p += '\n\n';
 if (isVideo()) {;
__p += '\n    <div role="' +
((__t = ( ariaRole )) == null ? '' : __t) +
'" class="img_holder" tabindex="0" aria-label="' +
((__t = ( I18n.t('photo_item.open_video', { altText: altText() }) )) == null ? '' : __t) +
'">\n        <video class="video-js vjs-default-skin layer_video" controls preload="auto" width="auto" height="auto" poster="' +
((__t = ( thumbnail_url )) == null ? '' : __t) +
'">\n            <source src="' +
((__t = ( source_url )) == null ? '' : __t) +
'" type="video/mp4" />\n        </video>\n    </div>\n';
};
__p += '\n\n<div class="info_content">\n    <div class="users_handle">' +
((__t = ( submitterAnchor(true) )) == null ? '' : __t) +
'</div>\n    ';
 if (shouldShowCaptions() && _.isTruthy(getTitle())) { ;
__p += '\n        <p class="users_caption">' +
((__t = ( decode_utf8(getTitle()) )) == null ? '' : __t) +
'</p>\n    ';
 } ;
__p += '\n</div>\n\n';
 if (shouldShowProductBadges()) { ;
__p += '\n    <i class="product_badge ' +
((__t = ( getProductBadgeClasses() )) == null ? '' : __t) +
'" aria-hidden="true"></i>\n';
 } else if (!gon.display_options.productBadgeLayout){ ;
__p += '\n    <i class="content_source ' +
((__t = ( contentSourceClass() )) == null ? '' : __t) +
'" aria-hidden="true"></i>\n';
 } ;


}
return __p
}